import React from "react";
import { useRfxProjectTypes } from "newui/features/Rfx/hooks/useRfxProjectTypes";
import { SelectWithLabel, BaseSelectWithLabelProps, SelectOption } from "../InputWithLabel/SelectWithLabel";

type ProjectTypeSelectProps = Omit<BaseSelectWithLabelProps, "options" | "isLoading">;

export const RfxProjectTypeSelect: React.FC<ProjectTypeSelectProps> = ({
  label = "Project Portfolio",
  placeholder = "Select project portfolio",
  ...rest
}) => {
  const { data: projectTypes = [], isLoading } = useRfxProjectTypes();

  const options: SelectOption[] = projectTypes
    .filter((t) => t.isActive)
    .map((t) => ({
      label: t.name,
      value: t.id,
    }));

  return (
    <SelectWithLabel
      options={options}
      isLoading={isLoading}
      label={label}
      placeholder={placeholder}
      {...rest}
    />
  );
};
